import moment from "moment";
import { inject, injectable } from "tsyringe";
import { Api } from "./Api";

@injectable()
export class BusinessCaseService
{
    protected api: Api;

    constructor(@inject(Api) api: Api) 
    {
        this.api = api;
    }    

    public async get(): Promise<any[]>
    {
        let transports = await this.api.get<any[]>('/transports');
        transports.forEach(transport => {
            this.adjustTransport(transport);
        });
        return transports;
    }

    public async getOne(id: number|string): Promise<any>
    {
        let transport = await this.api.get<any>('/transports/' + id.toString());
        this.adjustTransport(transport);
        return transport;
    }

    public async saveDelay(id: number, time: Date, delayReasonId: number)
    {
        let updatedTransport = await this.api.post('/transports/' + id.toString() + '/save-delay', {
            time: time,
            reasonId: delayReasonId
        });
        this.adjustTransport(updatedTransport);
        return updatedTransport;
    }

    /**
     * Set loaded
     * 
     * @param id Transport ID
     * @param realWeight Real Weight
     * @param deliveryNote Delivery Note
     * @param apu Actual Pick Up date (NULL = will be set as current time)
     */
    public async setLoaded(id: number, realWeight: string, deliveryNote: string, apu: Date = null)
    {
        if(apu === null) {
            apu = new Date();
        }
        let updatedTransport = await this.api.post('/transports/' + id.toString() + '/set-loaded', {
            realWeight: realWeight,
            deliveryNote: deliveryNote,
            apu: moment(apu).format()
        });
        this.adjustTransport(updatedTransport);
        return updatedTransport;
    }

    /**
     * Zaradi obchodni pripad id do fronty pro drivejsi mozny prijezd "MUZU DRIV"
     * 
     * @param id ID Obch. pripadu
     * @param soonerTime Od kdy mohu drive
     * @param extraTime Cas potrebny k pristaveni na nakladku/vykladku (stojim opodal)
     */
    public async saveSoonerQueue(id: number, soonerTime: Date, extraTime: number): Promise<any>
    {
        let updatedTransport = await this.api.post('/transports/' + id.toString() + '/save-sooner-queue', {
            time: soonerTime,
            extraTime: extraTime
        });
        this.adjustTransport(updatedTransport);
        return updatedTransport;
    }

    /**
     * Akceptovat nabizeny drivejsi cas
     * @param queueId 
     * @returns 
     */
    public async acceptQueueOffer(queueId: number): Promise<any>
    {
        let updatedTransport = await this.api.get('/queue/accept-offer/' + queueId.toString());
        this.adjustTransport(updatedTransport);
        return updatedTransport;
    }

    /**
     * Odmitnout nabizeny drivejsi cas
     * @param queueId 
     * @returns 
     */
    public async rejectQueueOffer(queueId: number): Promise<any>
    {
        let updatedTransport = await this.api.get('/queue/reject-offer/' + queueId.toString());
        this.adjustTransport(updatedTransport);
        return updatedTransport;
    }


    public async getDelayReasons()
    {
        return await this.api.get<any[]>('/delay-reasons');
    }


    protected adjustTransport(transport: any): void
    {
        // if(transport.typeIdent == 'export') {
        //     transport.loadTime = transport.eventTimeFrom ?? null;
        //     transport.delayedLoadTime = transport.currentLoadDelayTime ?? null;
        //     transport.unloadTime = transport.rtdDate ? (transport.rtdDate + ' ' + transport.rtdTime) : null;
        //     transport.delayedUnloadTime = transport.currentUnloadDelayTime ?? null;
        // }
        // else {
        //     transport.unloadTime = transport.eventTimeFrom ?? null;
        //     transport.delayedUnloadTime = transport.currentLoadDelayTime ?? null;
        //     transport.loadTime = transport.rtdDate ? (transport.rtdDate + ' ' + transport.rtdTime) : null;
        //     transport.delayedLoadTime = transport.currentUnloadDelayTime ?? null;
        // }

        // transport.isLoaded = transport.statusIdent != 'new' && transport.statusIdent != 'ordered';
    }

}